import axios from "../../axios/index.js"

export default {
    getAll(id) {
        return axios.get("reclammation/getAll/" + id, { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } });
    },
    getAllforAdmin() {
        return axios.get("reclammation", { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } });
    },
    add(body) {
        return axios.post("reclammation", body, { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } });
    },
    AddResponse(id, reponse) {

        return axios.put("reclammation/" + id, { 'reponse': reponse }, { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } });
    },

    update(body) {
        return axios.post("reclammation/update", body, { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } });
    },
    delete(id) {
        return axios.delete("reclammation/delete/" + id, { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } });
    },
    //*****************************************Lsite des réclammations passées par telephoniste***************************************** */
    getAllByTele() {
        return axios.get("reclammation/RecTelephoniste/", { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } });
    },
}